import {
  ContentLayout,
  HeaderBreadcrumbs,
  Loader,
  useDropdownApis,
  usePermission,
} from "../../../shared";
import * as React from "react";
import {
  Button,
  Stack,
  Card,
  Switch,
  Typography,
  Grid,
  TextField,
  Radio,
  FormHelperText,
  Box,
  FormControlLabel,
  Divider,
  Chip,
} from "@mui/material";
import InputControl from "../../../shared/components/InputControl";
import { useParams } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { useClientAccountDetails } from "../hooks";
import { DayPicker } from "../../Coupons";
import AddIcon from "@mui/icons-material/Add";
import { ClientAccountRejectionConfirmation } from "../components";

const options = [
  {
    label: "First",
    value: 1,
  },
  {
    label: "Second",
    value: 2,
  },
  {
    label: "Third",
    value: 3,
  },
  {
    label: "Fourth",
    value: 4,
  },
];

const dueDaysOption = [
  {
    value: "7",
    label: "7 days from statement date",
  },
  {
    value: "14",
    label: "14 days from statement date",
  },
  {
    value: "21",
    label: "21 days from statement date",
  },
  {
    value: "28",
    label: "28 days from statement date",
  },
];

export const CreateOrEditClientAccount = () => {
  const { id } = useParams();
  const [, forceUpdate] = React.useState();
  const [, forceUpdate2] = React.useState();

  const validator = React.useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      validators: {
        greaterThanZero: {
          required: true,
          message: 'The :attribute must be greater than 0.',
          rule: (val) => {
            return val > 0;
          }
        }
      }
    })
  );

  const validator2 = React.useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate2 },
    })
  );

  const {
    isRequestDetailsPage,
    isEditPage,
    isCreatePage,
    state,
    globalData,
    handleChange,
    onDayPicker,
    onCreateClientAccount,
    isStoreAdmin,
    value,
    setValue,
    handleAddressSection,
    onDeleteEmails,
    onUpdateClientAccount,
    triggerRejectDialog,
    handleApproveRequest,
  } = useClientAccountDetails({ isList: false, id: id, isCreate: true });

  const { isLoading, updateData, details } = state;
  const { storeList } = useDropdownApis({ isStoreList: !isStoreAdmin });
  const canRejectRequest = usePermission("client-account-delete");

  const title = isEditPage ? details.account_name : "New Client Account";

  const optionsStores = storeList?.map((item) => ({
    label: item.name,
    value: item.id,
  }));

  const [email, setEmail] = React.useState("");
  const [email2, setEmail2] = React.useState("");

  const onClientAccountSubmit = () => {
    if (validator.current.allValid()) {
      if (isEditPage) onUpdateClientAccount();
      else if (isCreatePage) onCreateClientAccount();
      else if (isRequestDetailsPage) handleApproveRequest();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  React.useEffect(() => {
    if (!updateData.bill_day) {
      setValue(1);
    } else {
      setValue(2);
    }
  }, [updateData.bill_day]);

  return (
    <ContentLayout
      title={title}
      rightContent={
        <Stack flexDirection="row" gap="24px">
          <React.Fragment>
            {isRequestDetailsPage && canRejectRequest && (
              <Button
                type="button"
                size="medium"
                variant="text"
                color="error"
                disabled={state.isSaveButtonBusy}
                onClick={() => triggerRejectDialog(true)}
              >
                Reject
              </Button>
            )}

            <Button
              type="button"
              size="medium"
              variant="contained"
              disabled={state.isSaveButtonBusy}
              onClick={() => onClientAccountSubmit()}
            >
              {isRequestDetailsPage ? "Approve" : "Save"}
            </Button>
          </React.Fragment>
        </Stack>
      }
      breadcrumbs={
        <HeaderBreadcrumbs
          links={[
            {
              name: "Dashboard",
              href: isStoreAdmin ? "/store-admin" : "/",
            },
            {
              name: "Client Account",
              href: isStoreAdmin
                ? `/store-admin/client-account-v2`
                : `/client-account-v2`,
            },
            isEditPage
              ? {
                name: details?.account_name,
                href: isStoreAdmin
                  ? `/store-admin/client-account-v2/details/${id}`
                  : `/client-account-v2/details/${id}`,
              }
              : null,
            { name: isEditPage ? "Edit" : "Create" },
          ].filter(Boolean)}
        />
      }
    >
      {isLoading && (isEditPage || isRequestDetailsPage) ? (
        <Loader />
      ) : (
        <>
          <Card sx={{ marginBottom: "20px" }}>
            {validator.current.purgeFields()}
            <Stack p="24px 24px 16px">
              <Stack direction="row" gap="24px" width="100%">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ width: "150px" }}
                    >
                      Account Details
                    </Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Stack gap="20px">
                      <InputControl
                        name="account_name"
                        label="Client Account Name *"
                        value={updateData.account_name}
                        onChange={handleChange}
                        error={validator.current.message(
                          "Client Account Name",
                          updateData.account_name,
                          "required"
                        )}
                        helperText={validator.current.message(
                          "Client Account Name",
                          updateData.account_name,
                          "required"
                        )}
                      />
                      <InputControl
                        name="abn_number"
                        label="ABN Number"
                        value={updateData.abn_number}
                        onChange={handleChange}
                      />
                      {id && (
                        <InputControl
                          name="abn_number"
                          label="Account No"
                          value={updateData.number}
                          disabled
                        />
                      )}
                      {!isStoreAdmin && (
                        <InputControl
                          type="dropdown"
                          disableClearable
                          options={optionsStores}
                          getOptionLabel={(option) => option.label}
                          disabled={!isCreatePage ? true : false}
                          value={
                            optionsStores.length > 0 && updateData?.store_id
                              ? optionsStores.find(
                                (c) => c.value === updateData?.store_id
                              )
                              : null
                          }
                          onChange={(e, newValue) => {
                            handleChange({
                              target: {
                                name: "store_id",
                                value: newValue?.value || "",
                              },
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Store"
                              required
                              error={validator.current.message(
                                "Store",
                                updateData.store_id,
                                "required"
                              )}
                              helperText={validator.current.message(
                                "Store",
                                updateData.store_id,
                                "required"
                              )}
                            />
                          )}
                        />
                      )}
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Typography
                          variant="subtitle1"
                          lineHeight="19px"
                          fontWeight={600}
                        >
                          Account Status
                        </Typography>
                        <Switch
                          name="status"
                          defaultChecked={updateData.status ? true : false}
                          value={updateData.status}
                          onChange={handleChange}
                        />
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
              </Stack>
            </Stack>

            {/* Address Section */}
            {(isCreatePage || isRequestDetailsPage) && (
              <React.Fragment>
                <Divider />
                <Stack p="24px 24px 16px">
                  <Stack direction="row" gap="24px" width="100%">
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={4}>
                        <Typography
                          variant="subtitle1"
                          fontWeight={600}
                          sx={{ width: "150px" }}
                        >
                          Addresses*
                        </Typography>
                      </Grid>
                      <Grid item sm={8}>
                        <Stack sx={{ gap: "16px", py: "16px" }}>
                          {updateData.addresses?.map((val, i) => (
                            <Stack
                              key={i}
                              gap="20px"
                              sx={{
                                pb: "16px",
                                borderBottom:
                                  i !== updateData.addresses.length - 1
                                    ? "1px solid rgba(230, 230, 230, 1)"
                                    : "none",
                              }}
                            >
                              <Stack
                                sx={{
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  minHeight: "40px",
                                }}
                              >
                                <Typography
                                  variant="subtitle1"
                                  fontWeight={600}
                                  lineHeight="19px"
                                >
                                  Address {i + 1}
                                </Typography>

                                {updateData.addresses.length > 1 ? (
                                  <Button
                                    variant="text"
                                    color="info"
                                    onClick={() =>
                                      handleAddressSection("remove", i)
                                    }
                                    sx={{
                                      pt: "10px",
                                      height: "40px",
                                      color: "#A04D3D",
                                    }}
                                  >
                                    Remove
                                  </Button>
                                ) : null}
                              </Stack>
                              <InputControl
                                name="name"
                                label="Name *"
                                value={val.name}
                                onChange={(e) => handleChange(e, i)}
                                error={validator.current.message(
                                  `Name % ${` `.repeat(i)}`,
                                  val.name,
                                  "required"
                                )}
                                helperText={validator.current.message(
                                  `Name % ${` `.repeat(i)}`,
                                  val.name,
                                  "required"
                                )}
                              />
                              <InputControl
                                name="address"
                                label="Address *"
                                value={val.address}
                                onChange={(e) => handleChange(e, i)}
                                error={validator.current.message(
                                  `Address % ${` `.repeat(i)}`,
                                  val.address,
                                  "required"
                                )}
                                helperText={validator.current.message(
                                  `Address % ${` `.repeat(i)}`,
                                  val.address,
                                  "required"
                                )}
                              />
                              <InputControl
                                name="email"
                                label="Email Id *"
                                value={val.email}
                                onChange={(e) => handleChange(e, i)}
                                error={validator.current.message(
                                  `Email Id % ${` `.repeat(i)}`,
                                  val.email,
                                  "required|email"
                                )}
                                helperText={validator.current.message(
                                  `Email Id % ${` `.repeat(i)}`,
                                  val.email,
                                  "required|email"
                                )}
                              />
                              <Stack sx={{ flexDirection: "row", gap: "20px" }}>
                                <InputControl
                                  type="dropdown"
                                  id="country_code"
                                  disableClearable
                                  options={globalData.country_codes ?? []}
                                  getOptionLabel={(option) => option.label}
                                  value={
                                    globalData?.country_codes?.length > 0 &&
                                      val.country_code
                                      ? globalData?.country_codes?.find(
                                        (c) => c.value === val.country_code
                                      )
                                      : null
                                  }
                                  onChange={(e, newValue) => {
                                    handleChange(
                                      {
                                        target: {
                                          name: "country_code",
                                          value: newValue.value,
                                        },
                                      },
                                      i
                                    );
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Country code"
                                      required
                                      error={validator.current.message(
                                        `Country Code % ${` `.repeat(i)}`,
                                        val.country_code,
                                        "required"
                                      )}
                                      helperText={validator.current.message(
                                        `Country Code % ${` `.repeat(i)}`,
                                        val.country_code,
                                        "required"
                                      )}
                                    />
                                  )}
                                />
                                <InputControl
                                  name="phone"
                                  label="Phone Number *"
                                  value={val.phone}
                                  onChange={(e) => handleChange(e, i)}
                                  error={validator.current.message(
                                    `Phone Number % ${` `.repeat(i)}`,
                                    val.phone,
                                    "required"
                                  )}
                                  helperText={validator.current.message(
                                    `Phone Number % ${` `.repeat(i)}`,
                                    val.phone,
                                    "required"
                                  )}
                                />
                              </Stack>
                            </Stack>
                          ))}
                        </Stack>

                        <Button
                          variant="text"
                          color="info"
                          startIcon={<AddIcon />}
                          onClick={() => handleAddressSection("add")}
                          sx={{ pt: "10px", width: "100%" }}
                        >
                          Add New Address
                        </Button>
                      </Grid>
                    </Grid>
                  </Stack>
                </Stack>
              </React.Fragment>
            )}

            <Divider />
            <Stack p="24px 24px 16px">
              <Stack direction="row" gap="24px" width="100%">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ width: "200px" }}
                    >
                      Auto-send Statements to
                    </Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Stack gap="6px">
                      <Stack
                        sx={{
                          flexDirection: "row",
                          gap: "20px",
                        }}
                      >
                        <InputControl
                          name="statement_emails"
                          label="Email Id *"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          error={
                            email
                              ? validator2.current.message(
                                "Email",
                                email,
                                "required|email"
                              )
                              : null
                          }
                          helperText={
                            email
                              ? validator2.current.message(
                                "Email",
                                email,
                                "required|email"
                              )
                              : null
                          }
                        />
                        <Button
                          sx={{
                            height: "44px !important",
                          }}
                          disabled={!email}
                          onClick={() => {
                            if (validator2.current.allValid()) {
                              handleChange({
                                target: {
                                  value: email,
                                  name: "statement_emails",
                                },
                              });
                              setEmail("");
                              validator2.current.hideMessages();
                            } else {
                              validator2.current.showMessages();
                              forceUpdate2(1);
                            }
                          }}
                        >
                          Add
                        </Button>
                      </Stack>
                      <FormHelperText sx={{ color: "#C60808" }}>
                        {validator.current.message(
                          "statement emails",
                          updateData.statement_emails?.length > 0
                            ? updateData.statement_emails
                            : "",
                          "required"
                        )}
                        <Stack
                          sx={{
                            flexDirection: "row",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "12px",
                          }}
                        >
                          {updateData.statement_emails?.map((data, index) => (
                            <Chip
                              key={index}
                              label={
                                <Typography variant="body2" fontSize="12px">
                                  {data}
                                </Typography>
                              }
                              onDelete={() =>
                                onDeleteEmails({
                                  name: "statement_emails",
                                  value: data,
                                })
                              }
                              sx={{
                                backgroundColor: "#F2F2F2",
                                height: "30px",
                                "& .MuiChip-deleteIcon": {
                                  color: "#CCCCCC",
                                },
                              }}
                            />
                          ))}
                        </Stack>
                      </FormHelperText>
                    </Stack>
                  </Grid>
                </Grid>
              </Stack>
            </Stack>
            <Divider />
            <Stack p="24px 24px 16px">
              <Stack direction="row" gap="24px" width="100%">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ width: "200px" }}
                    >
                      Auto-send Invoices to
                    </Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Stack gap="6px">
                      <Stack
                        sx={{
                          flexDirection: "row",
                          gap: "20px",
                        }}
                      >
                        <InputControl
                          name="invoice_emails"
                          label="Email Id *"
                          value={email2}
                          onChange={(e) => setEmail2(e.target.value)}
                          error={
                            email2
                              ? validator2.current.message(
                                "Email ",
                                email2,
                                "required|email"
                              )
                              : null
                          }
                          helperText={
                            email2
                              ? validator2.current.message(
                                "Email ",
                                email2,
                                "required|email"
                              )
                              : null
                          }
                        />
                        <Button
                          sx={{
                            height: "44px !important",
                          }}
                          disabled={!email2}
                          onClick={() => {
                            if (email2 && validator2.current.allValid()) {
                              handleChange({
                                target: {
                                  value: email2,
                                  name: "invoice_emails",
                                },
                              });
                              setEmail2("");
                              validator2.current.hideMessages();
                            } else {
                              validator2.current.showMessages();
                              forceUpdate2(1);
                            }
                          }}
                        >
                          Add
                        </Button>
                      </Stack>
                      <FormHelperText sx={{ color: "#C60808" }}>
                        {validator.current.message(
                          "invoice emails",
                          updateData.invoice_emails?.length > 0
                            ? updateData.invoice_emails
                            : "",
                          "required"
                        )}
                        <Stack
                          sx={{
                            flexDirection: "row",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "12px",
                          }}
                        >
                          {updateData.invoice_emails?.map((data, index) => (
                            <Chip
                              key={index}
                              label={
                                <Typography variant="body2" fontSize="12px">
                                  {data}
                                </Typography>
                              }
                              onDelete={() =>
                                onDeleteEmails({
                                  name: "invoice_emails",
                                  value: data,
                                })
                              }
                              sx={{
                                backgroundColor: "#F2F2F2",
                                height: "30px",
                                "& .MuiChip-deleteIcon": {
                                  color: "#CCCCCC",
                                },
                              }}
                            />
                          ))}
                        </Stack>
                      </FormHelperText>
                    </Stack>
                  </Grid>
                </Grid>
              </Stack>
            </Stack>
          </Card>

          <Card>
            <Stack p="24px 24px 16px">
              <Stack direction="row" gap="24px" width="100%">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ width: "150px" }}
                    >
                      Credit Limit
                    </Typography>
                  </Grid>
                  <Grid item sm={8}>
                    {!isEditPage && (
                      <InputControl
                        name="carry_forward"
                        type="number"
                        label="Opening Credit / Carry Forward ($)"
                        value={updateData.carry_forward}
                        onChange={handleChange}
                        error={validator.current.message(
                          "Opening Credit",
                          updateData.carry_forward,
                          "required|numeric|min:0,num"
                        )}
                        helperText={validator.current.message(
                          "Opening Credit",
                          updateData.carry_forward,
                          "required|numeric|min:0,num"
                        )}
                        required
                      />
                    )}
                    <Stack direction="row" spacing={2} mt={isEditPage ? 0 : 2}>
                      <InputControl
                        label="Maximum Credit Amount (In $)"
                        type="number"
                        name="credit_limit"
                        value={updateData.credit_limit}
                        onChange={handleChange}
                        error={validator.current.message(
                          "Maximum Credit Amount",
                          updateData.credit_limit,
                           "required|greaterThanZero"
                        )}
                        helperText={validator.current.message(
                          "Maximum Credit Amount",
                          updateData.credit_limit,
                           "required|greaterThanZero"
                        )}
                        required
                      />

                      <Grid item xs={12} sm={8}>
                        <Typography variant="subtitle1" fontWeight={600}>
                          Restrict Credit
                        </Typography>
                        <Typography color="#636363">
                          Restrict user to maximum credit amount only.
                        </Typography>
                      </Grid>
                      <Grid item sm={4}>
                        <Stack gap="20px" alignItems="flex-end">
                          <Switch
                            name="restrict_usage"
                            defaultChecked={
                              updateData.restrict_usage ? true : false
                            }
                            value={updateData.restrict_usage}
                            onChange={handleChange}
                          />
                        </Stack>
                      </Grid>
                    </Stack>
                  </Grid>
                </Grid>
              </Stack>
            </Stack>
            <Divider />
            <Grid container spacing={2} sx={{ padding: "20px" }}>
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1" fontWeight={600}>
                  Statement Frequency
                </Typography>
              </Grid>
              <Grid item sm={8}>
                <Stack width={"100%"} gap="20px" direction="column">
                  <Stack direction="row" gap="24px">
                    <Typography width="95px" mt={1}>
                      Every
                    </Typography>
                    <Stack>
                      <Stack direction="row" gap="24px">
                        <InputControl
                          type="number"
                          name="bill_duration"
                          width="48px"
                          value={updateData.bill_duration}
                          onChange={handleChange}
                          error={validator.current.message(
                            "Bill duration",
                            updateData.bill_duration,
                            updateData.bill_period === 1
                              ? "required|numeric|min:1,num"
                              : updateData.bill_period === 2
                                ? "required|numeric|max:12,num|min:1,num"
                                : "required|numeric|min:1,num"
                          )}
                        />

                        <InputControl
                          type="select"
                          name="bill_period"
                          label=""
                          value={updateData.bill_period}
                          optionValue={
                            globalData?.client_accounts?.bill_period ?? []
                          }
                          width="150px"
                          onChange={(e, v) => handleChange(e)}
                          error={validator.current.message(
                            "Bill Period",
                            updateData.bill_period,
                            "required"
                          )}
                        />
                      </Stack>
                      <FormHelperText sx={{ color: "#C60808" }}>
                        {validator.current.message(
                          "Bill duration",
                          updateData.bill_duration,
                          updateData.bill_period === 1
                            ? "required|numeric|min:1,num"
                            : updateData.bill_period === 2
                              ? "required|numeric|max:12,num|min:1,num"
                              : "required|numeric|min:1,num"
                        )}
                        {validator.current.message(
                          "Bill Period",
                          updateData.bill_period,
                          "required"
                        )}
                      </FormHelperText>
                    </Stack>
                  </Stack>
                  {updateData.bill_period === 1 ? (
                    <Stack direction="row" gap="24px" spacing={8}>
                      <Typography width="89">Day</Typography>
                      <Stack width="100%">
                        <DayPicker
                          options={globalData?.client_accounts?.bill_day}
                          onDayPicker={onDayPicker}
                          data={updateData?.bill_day}
                        />
                        <FormHelperText sx={{ color: "#C60808" }}>
                          {updateData.bill_period === 1 &&
                            validator.current.message(
                              "Bill Day",
                              updateData.bill_day,
                              "required"
                            )}
                        </FormHelperText>
                      </Stack>
                    </Stack>
                  ) : updateData.bill_period === 2 ? (
                    <>
                      <Stack
                        direction="row"
                        gap="22px"
                        alignItems={"flex-start"}
                      >
                        <FormControlLabel
                          control={
                            <Radio
                              checked={value === 1 ? true : false}
                              value={1}
                              onClick={() => {
                                setValue(1);
                              }}
                            />
                          }
                          label="On day"
                        />

                        <Box>
                          <InputControl
                            type="number"
                            name="bill_date"
                            value={updateData.bill_date}
                            onChange={handleChange}
                            disabled={value === 2}
                            error={
                              value === 1 &&
                              validator.current.message(
                                "Bill Date",
                                updateData.bill_date,
                                "required|numeric|max:31,num|min:1,num"
                              )
                            }
                            width={"45px"}
                          />
                          <FormHelperText sx={{ color: "#C60808" }}>
                            {value === 1 &&
                              validator.current.message(
                                "Bill Date",
                                updateData.bill_date,
                                "required|numeric|max:31,num|min:1,num"
                              )}
                          </FormHelperText>
                        </Box>
                      </Stack>
                      <Stack direction="row" gap="24px" alignItems="flex-start">
                        <FormControlLabel
                          control={
                            <Radio
                              checked={value === 2 ? true : false}
                              value={2}
                              onClick={() => setValue(2)}
                            />
                          }
                          label="On the"
                        />
                        <Stack>
                          <Stack direction="row" gap="25px">
                            <InputControl
                              type="select"
                              name="bill_date2"
                              value={updateData.bill_date2}
                              optionValue={options}
                              disabled={value === 1}
                              onChange={handleChange}
                              width="180px"
                              error={
                                value === 2 &&
                                validator.current.message(
                                  "Bill Date",
                                  updateData.bill_date2,
                                  "required"
                                )
                              }
                              helperText={
                                value === 2 &&
                                validator.current.message(
                                  "Bill Date",
                                  updateData.bill_date2,
                                  "required"
                                )
                              }
                            />
                            <InputControl
                              type="select"
                              name="bill_day"
                              value={updateData.bill_day}
                              optionValue={
                                globalData?.client_accounts?.bill_day ?? []
                              }
                              disabled={value === 1}
                              onChange={handleChange}
                              width="180px"
                              error={
                                value === 2 &&
                                validator.current.message(
                                  "Bill Day",
                                  updateData.bill_day,
                                  "required"
                                )
                              }
                              helperText={
                                value === 2 &&
                                validator.current.message(
                                  "Bill Day",
                                  updateData.bill_day,
                                  "required"
                                )
                              }
                            />
                          </Stack>
                        </Stack>
                      </Stack>
                    </>
                  ) : (
                    ""
                  )}
                </Stack>
              </Grid>
            </Grid>
            <Box mt={3}>
              <Divider />
            </Box>
            <Divider />
            <Stack p="24px 24px 16px">
              <Stack direction="row" gap="24px" width="100%">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ width: "200px" }}
                    >
                      Due Date*
                    </Typography>
                  </Grid>
                  <Grid item sm={8}>
                    <Stack>
                      <Stack
                        sx={{
                          flexDirection: "row",
                          gap: "20px",
                        }}
                      >
                        <InputControl
                          type="select"
                          name="due_days"
                          // label="Status"
                          value={updateData.due_days ?? ""}
                          optionValue={dueDaysOption}
                          onChange={(e) => handleChange(e)}
                        />
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
              </Stack>
            </Stack>
          </Card>
        </>
      )}

      {/* CLien account rejection confirmation modal */}

      <ClientAccountRejectionConfirmation
        open={state.isRejectDialogOpen}
        handleCloseDialog={() => triggerRejectDialog(false)}
      />
    </ContentLayout>
  );
};
